import { ReactNode } from 'react';

import * as Yup from 'yup';

export interface CreationFlowProps {
  isIR?: boolean;
  afterIRCreateAction?: (id?: number) => Promise<unknown>;
  afterCreateAction?: () => void;
  searchComponents?: ReactNode;
  calendarComponents?: ReactNode;
  validationSchema?: Yup.ObjectSchema<any>;
}

export const CommunicationTypeId = 5;
export const NoteTypeId = 4;
export const WaiverTypeId = 3;
export const MMCompliance = 2;

export type ActivityTypeIdType =
  | typeof CommunicationTypeId
  | typeof NoteTypeId
  | typeof WaiverTypeId
  | typeof MMCompliance;
